(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.headerBounds = { top: 0, bottom: 0 };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
    this._onResize = this._onResize.bind(this);
    this._ensureStartedOnResize = this._ensureStartedOnResize.bind(this);
    this._resizeTimer = 0;
  }

  _getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
    window.addEventListener('resize', this._ensureStartedOnResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('resize', this._ensureStartedOnResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this._onResize);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = 0;
  }

  _onResize() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._resizeTimer = 0;
      if (!this._started || !this.header) return;
      this._measure();

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const eps = this.THRESHOLD_EPS;
      if (this.currentScrollTop <= (this.headerBounds.top + eps)) {
        this._setState('reset');
      }
      this.onScroll();
    }, 120);
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _ensureStartedOnResize() {
    if (!this._started) this._start();
  }

  _start() {
    if (this._started) return;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-header') ||
      null;

    if (!this.header) return;

    this._started = true;

    window.removeEventListener('resize', this._ensureStartedOnResize);

    this.headerSection = this.header.querySelector('.header-section') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const outerH = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const innerH = this.headerSection
      ? Math.ceil(this.headerSection.getBoundingClientRect().height || 0)
      : 0;
    const h = Math.max(outerH, innerH);
    const next = `${h}px`;
    const prev = document.documentElement.style.getPropertyValue('--header-height');
    if (prev !== next) {
      document.documentElement.style.setProperty('--header-height', next);
    }

    const top = this.headerSection ? this._getDocumentTop(this.headerSection) : 0;
    this.headerBounds = { top, bottom: top + h };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (window.getComputedStyle(this.header).display === 'none') {
      this.currentScrollTop = scrollTop;
      return;
    }

    const layoutRect = this.headerSection?.getBoundingClientRect();
    if (!layoutRect || layoutRect.height < 1) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const eps = this.THRESHOLD_EPS;
    let hb = this.headerBounds;
    if (!(hb.bottom > hb.top + eps)) {
      this._measure();
      hb = this.headerBounds;
    }
    if (!(hb.bottom > hb.top + eps)) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (!pastBottom) {
      if (beforeTop) {
        this._setState('reset');
      } else if (scrollTop < this.currentScrollTop) {
        this._setState('revealed');
      } else {
        this._setState('reset');
      }
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-header"]) return;
  try {
    
  class MobileStickyHeader extends HTMLElement {
    constructor() {
      super();
      this._onLayoutResize = this._onLayoutResize.bind(this);
      this._layoutResizeTimer = 0;
    }

    connectedCallback() {
      this.header =
        document.getElementById('shopify-section-mobile-header') ||
        this.closest('.shopify-section-mobile-header');
      if (!this.header) return;
      this.headerSection = this.header.querySelector('.mobile-header');
      if (!this.headerSection) return;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this._onLayoutResize, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this._onLayoutResize);
      if (this._layoutResizeTimer) clearTimeout(this._layoutResizeTimer);
      this._layoutResizeTimer = 0;
    }

    _onLayoutResize() {
      if (this._layoutResizeTimer) clearTimeout(this._layoutResizeTimer);
      this._layoutResizeTimer = setTimeout(() => {
        this._layoutResizeTimer = 0;
        if (!this.header || !this.headerSection) return;
        if (!window.matchMedia('(max-width: 920px)').matches) return;
        this.createObserver();
        this.onScrollHandler();
      }, 120);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-mobile-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-mobile-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky', 'animate');
    }
  }

  customElements.define('mobile-sticky-header', MobileStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header"]) return;
  try {
    
class StickySecondaryHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.headerBounds = { top: 0, bottom: 0 };
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
    this._onResize = this._onResize.bind(this);
    this._ensureStartedOnResize = this._ensureStartedOnResize.bind(this);
    this._resizeTimer = 0;
  }

  _getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
    window.addEventListener('resize', this._ensureStartedOnResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('resize', this._ensureStartedOnResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this._onResize);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = 0;
  }

  _onResize() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._resizeTimer = 0;
      if (!this._started || !this.header) return;
      this._measure();
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const eps = this.THRESHOLD_EPS;
      if (this.currentScrollTop <= (this.headerBounds.top + eps)) {
        this._setState('reset');
      }
      this.onScroll();
    }, 120);
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _ensureStartedOnResize() {
    if (!this._started) this._start();
  }

  _start() {
    if (this._started) return;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header = this.closest('.shopify-section-header');
    if (!this.header) return;

    this._started = true;

    window.removeEventListener('resize', this._ensureStartedOnResize);

    this.headerSection =
      this.header.querySelector('.secondary-header-section') ||
      this.header.querySelector('.header-section') ||
      this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const outerH = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const innerH = this.headerSection
      ? Math.ceil(this.headerSection.getBoundingClientRect().height || 0)
      : 0;
    const h = Math.max(outerH, innerH);
    const next = `${h}px`;
    const primarySticky = document.querySelector('sticky-header');
    const skipGlobalHeaderHeight =
      primarySticky && this.header && !this.header.contains(primarySticky);
    if (!skipGlobalHeaderHeight) {
      const prev = document.documentElement.style.getPropertyValue('--header-height');
      if (prev !== next) {
        document.documentElement.style.setProperty('--header-height', next);
      }
    }

    const top = this.headerSection ? this._getDocumentTop(this.headerSection) : 0;
    this.headerBounds = { top, bottom: top + h };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (window.getComputedStyle(this.header).display === 'none') {
      this.currentScrollTop = scrollTop;
      return;
    }

    const layoutRect = this.headerSection?.getBoundingClientRect();
    if (!layoutRect || layoutRect.height < 1) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const eps = this.THRESHOLD_EPS;
    let hb = this.headerBounds;
    if (!(hb.bottom > hb.top + eps)) {
      this._measure();
      hb = this.headerBounds;
    }
    if (!(hb.bottom > hb.top + eps)) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (scrollTop <= (hb.bottom + eps)) {
      this._setState('reset');
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-secondary-header', StickySecondaryHeader);

  } catch(e) { console.error(e); }
})();
})();
